import { jsx as _jsx } from "theme-ui/jsx-runtime";
import sizes from "./sizes";
/**
 * An icon showing up.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function ChevronUpIcon({ className, size = "xsmall" }) {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: "middle",
        }, className: className, viewBox: "0 0 15 15", children: _jsx("path", { fill: "currentColor", transform: "matrix(1 0 0 -1 2 11)", d: "M10.161.633l.678.734-5.386 4.976L.161 1.454.839.719l4.614 4.262z" }) }));
}
//# sourceMappingURL=ChevronUpIcon.js.map